<script lang="ts">
    import { reviewsIconCollectionManagerContextToken } from "@apps/reviews/context_tokens";
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { createEventDispatcher } from "svelte";

    import BaseButton from "@components/Buttons/BaseButton.svelte";
    import Icon from "@components/Icon.svelte";

    export let value: number;
    export let starsNum = 5;
    export let iconWidth: string | number = 34;
    export let iconHeight: string | number = 34;

    let hoverRating: number | null = null;
    let stars = Array.from({ length: starsNum }, (__, i) => i + 1);

    const dispatch = createEventDispatcher();

    const handleHover = (id: number | null) => {
        hoverRating = id;
    };

    const handleRate = (value: number) => {
        dispatch("change", { value });
    };

    const icon$ = getTypedContext(
        reviewsIconCollectionManagerContextToken
    ).getIconCollection();

    $: getReviewIcon = (star: number) => {
        if (hoverRating) {
            if (hoverRating < star) {
                return $icon$?.empty;
            } else if (hoverRating >= star) {
                return $icon$?.filled;
            }
        } else if (value >= star) {
            return $icon$?.filled;
        }

        return $icon$?.empty;
    };
</script>

<fieldset class="gw-rv-rating-input gw-default-reset">
    {#each stars as star}
        <BaseButton
            aria-label="{star} out of 5 stars"
            class="gw-rv-rating-input__star"
            on:mouseover={() => handleHover(star)}
            on:focus={() => handleHover(star)}
            on:mouseleave={() => handleHover(null)}
            on:blur={() => handleHover(null)}
            on:click={() => handleRate(star)}
            type="button"
        >
            <Icon
                width={iconWidth}
                height={iconHeight}
                class="gw-rv-rating-input__star-icon"
            >
                <svelte:component this={getReviewIcon(star)} />
            </Icon>
        </BaseButton>
    {/each}
</fieldset>

<style lang="postcss">
    .gw-rv-rating-input {
        display: inline-flex;
        line-height: normal;
        border: none;

        :global(.gw-rv-rating-input__star) {
            cursor: pointer;
            padding-right: 1em;
        }

        @media all and (max-width: 344px) {
            :global(.gw-rv-rating-input__star) {
                padding-right: 0;
            }
        }

        :global(.gw-rv-rating-input__star:last-child) {
            padding-right: 0;
        }

        :global(.gw-rv-rating-input__star-icon) {
            color: var(--gw-rv-icon-starColor);
        }
    }
</style>
